import type { Ref } from 'vue';
import { DropdownItemLabel } from './DropdownItemLabel';
import type { DropdownItemTypes } from './DropdownItemTypes';
import { DropdownItemSeparator } from './DropdownItemSeparator';
import { DropdownItemBase } from './DropdownItemBase';
import { randomstring } from '@/utilities/utils';

/**
 * Allows us to group the items within a dropdown.
 */
export class DropdownItemGroup extends DropdownItemBase {
    public readonly items: DropdownItemTypes[];

    private guid: string;

    get uniqueLoopKey() {
        return this.guid;
    }

    private constructor(
        items: DropdownItemTypes[],
        showSeparator?: boolean,
        title?: string,
        hideDropDownItem?: Ref<boolean>,
        uniqueLoopKey?: string,
    ) {
        super();
        this.guid = uniqueLoopKey ?? title ?? randomstring('');

        this.items = [
            ...(title ? [DropdownItemLabel.create({ text: title, hideDropDownItem: hideDropDownItem })] : []),
            ...(showSeparator
                ? [
                      DropdownItemSeparator.create({
                          hideDropDownItem: hideDropDownItem,
                      }),
                  ]
                : []),
            ...items,
        ];
    }

    public static create(
        options: { title?: string; showSeparator?: boolean; items: DropdownItemTypes[] } & Partial<
            Pick<DropdownItemBase, 'hideDropDownItem' | 'uniqueLoopKey'>
        >,
    ) {
        return new DropdownItemGroup(options.items, options.showSeparator, options.title, options.hideDropDownItem, options.uniqueLoopKey);
    }
}
